import React, { useEffect, useState } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '../../ui/popover';

export function RootBadge({ nodeId }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => setOpen(false), 10000);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="text-xs font-semibold px-3 py-1.5 min-h-[32px] rounded-md border border-amber-400 text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors"
          data-testid={`root-badge-${nodeId}`}
        >
          Root <span className="opacity-70">ⓘ</span>
        </button>
      </PopoverTrigger>
      <PopoverContent side="bottom" className="w-64 text-sm" data-testid="root-explainer">
        <p className="font-semibold text-gray-900 mb-1">What is the Root?</p>
        <p className="text-gray-600 leading-snug">
          The tree is drawn from this person. Their parents go in the row above, their children below and
          their partner beside them. It only changes the layout, not anyone's access. The family owner can
          tap <span className="font-medium">Make Root</span> on another card to move it.
        </p>
        <p className="text-xs text-gray-400 mt-2">Tap anywhere to close</p>
      </PopoverContent>
    </Popover>
  );
}
